import React, { useEffect } from 'react'
import Wrapper from 'modules/reusables/wrapper'
import Tabs from './tabs'
import { setLocale } from 'store/slices/locale.slice'
import { useAppDispatch } from 'store/hooks'

interface IProps {
  locale?: any
  userId?: number
  userToken?: string
  padding: string
}

export const UserProfile = ({ locale, userId, userToken, padding }: IProps) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setLocale(locale))
  }, [locale])

  return (
    <Wrapper shadow={false} padding={padding}>
      <Tabs userId={userId} userToken={userToken} />
    </Wrapper>
  )
}

export default UserProfile
